module.exports = __webpack_public_path__ + "d04174646d9402dc5ff87fa7980bdb73.pdf";